import api from '../../plugins/api';

const checkCrmSidebarNotifications = ({ notificationIds }) => {
  return api.post('/api/notifications/sidebar/checkCrmSidebarNotifications', { notificationIds });
};

export default checkCrmSidebarNotifications;
